<template>
  <ais-pagination :padding="1">
    <template
      #default="{
        currentRefinement,
        nbPages,
        pages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
      }"
    >
      <ul class="pagination pagination-lg justify-content-center">
        <li v-if="!isFirstPage" class="page-item jump-to-first-page">
          <a
            :href="createURL(0)"
            class="page-link"
            @click.prevent="onRefine(refine, 0)"
          >
            ‹‹
          </a>
        </li>
        <li v-if="!isFirstPage" class="page-item">
          <a
            :href="createURL(currentRefinement - 1)"
            class="page-link"
            @click.prevent="onRefine(refine, currentRefinement - 1)"
          >
            ‹
          </a>
        </li>
        <li
          v-for="page in pages"
          :key="page"
          :class="{ 'page-item': true, active: page === currentRefinement }"
        >
          <a
            :href="createURL(page)"
            :class="{
              'page-link': true,
              'font-weight-bold': page === currentRefinement,
            }"
            @click.prevent="onRefine(refine, page)"
          >
            {{ page + 1 }}
          </a>
        </li>
        <li v-if="!isLastPage" class="page-item">
          <a
            :href="createURL(currentRefinement + 1)"
            class="page-link"
            @click.prevent="onRefine(refine, currentRefinement + 1)"
          >
            ›
          </a>
        </li>
        <li v-if="!isLastPage" class="page-item jump-to-last-page">
          <a
            :href="createURL(nbPages)"
            class="page-link"
            @click.prevent="onRefine(refine, nbPages)"
          >
            ››
          </a>
        </li>
      </ul>
    </template>
  </ais-pagination>
</template>

<script>
import { AisPagination } from 'vue-instantsearch';

export default {
  components: {
    AisPagination,
  },
  methods: {
    onRefine(refine, value) {
      refine(value);
      setTimeout(function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 200);
    },
  },
};
</script>
